var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.334958 10.0462C-0.111978 10.4931 -0.111978 11.2177 0.334958 11.6647C0.781895 12.1116 1.50652 12.1116 1.95346 11.6647L5.9998 7.61833L10.0463 11.6648C10.4932 12.1118 11.2179 12.1118 11.6648 11.6648C12.1117 11.2179 12.1117 10.4933 11.6648 10.0463L7.6183 5.99983L11.6645 1.95367C12.1114 1.50673 12.1114 0.782107 11.6645 0.335172C11.2175 -0.111764 10.4929 -0.111765 10.046 0.335171L5.9998 4.38133L1.95379 0.335325C1.50685 -0.111611 0.782226 -0.11161 0.335289 0.335326C-0.111647 0.782261 -0.111647 1.50689 0.335289 1.95382L4.3813 5.99983L0.334958 10.0462Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.adc8dbc886eace19508d8632eb77f633.svg";
export { ForwardRef as ReactComponent };